import { oc } from '@orpc/contract';
import { saveSimulatorEstimateInputSchema, simulatorEstimateSchema } from '../schemas/simulator.schemas.js';
/** Appends one evaluation exactly as the page computed it. Public: the simulator has no sign-in. */
export const saveSimulatorEstimateContract = oc
    .route({
    method: 'POST',
    path: '/simulator/estimates',
    tags: ['Simulator'],
    summary: 'Save an evaluation from the public depreciation simulator',
})
    .input(saveSimulatorEstimateInputSchema)
    .output(simulatorEstimateSchema);
//# sourceMappingURL=save-simulator-estimate.contract.js.map